module.exports = __webpack_public_path__ + "media/travel-agency-promo.mp4";